import { Button, SimpleGrid, Spacer } from '@chakra-ui/react';
import { FormStack } from '@inspire/ui/chakra/forms/Form';
import { PasswordControl } from '@inspire/ui/chakra/forms/PasswordInput';
import Layout from 'components/layout/Layout';
import { ProfilePageWrapper } from 'components/layout/ProfilPageWrapper';
import { Form, Formik, FormikConfig, FormikValues } from 'formik';
import { useState } from 'react';
import SubmitButton from 'components/forms/SubmitButton';
import { useMyProfile } from 'lib/hooks';

const AtelierSupPage = () => {
  const [showPassword, setShowPassword] = useState(false);

  const { setAndRefetchMyProfile, isSettingAndRefetchingMyProfile } =
    useMyProfile(null, {
      onSuccess: () => {
        window.location.href = 'https://article1asso.typeform.com/InspireSPVLS';
      },
    });

  const formik: FormikConfig<FormikValues> = {
    initialValues: { password: '' },
    onSubmit: (values) => {
      if (values.password !== 'inspire') {
        alert('Le mot de passe est incorrect');
      } else {
        setAndRefetchMyProfile({ referredBy: 'atelier' });
      }
    },
  };

  return (
    <>
      <Button onClick={() => setShowPassword(true)}>
        Répondre au questionnaire
      </Button>
      <Spacer mt={30} />
      {showPassword && (
        <Formik {...formik}>
          <Form>
            <FormStack>
              <SimpleGrid columns={[1, null, 2]} spacing={6}>
                <PasswordControl
                  name="password"
                  label="Mot de passe du questionnaire"
                />
                <SubmitButton
                  mt={8}
                  loadingText="Ouverture du questionnaire en cours"
                  isLoading={isSettingAndRefetchingMyProfile}
                  disabled={false}
                >
                  Valider
                </SubmitButton>
              </SimpleGrid>
            </FormStack>
          </Form>
        </Formik>
      )}
    </>
  );
};

AtelierSupPage.getWrappers = (page) => (
  <Layout variant="adaptative" rowVariant="gray" containerWidth="lg">
    <ProfilePageWrapper>{page}</ProfilePageWrapper>
  </Layout>
);

export default AtelierSupPage;
